import React, { useRef, useEffect } from "react";
import { Select } from "antd";
import { BarcodeOutlined } from "@ant-design/icons";

const ProductScanSelect = ({ onValueChange, value, options, placeholder, size, length, disabled, productRef }) => {
  const { Option } = Select;
  const bufferRef = useRef("");
  const timerRef = useRef(null);
  const isFocusedRef = useRef(false);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (!isFocusedRef.current) return;

      if (event.key === "Enter") {
        if (bufferRef.current.length > 0) {
          onValueChange?.(bufferRef.current, true);
          bufferRef.current = "";
        }
      } else if (event.key !== "Shift") {
        bufferRef.current += event.key;
        clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => (bufferRef.current = ""), 300);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [onValueChange]);


  const handleChange = (val) => {
    onValueChange?.(val, false);
  };

  return (
      <Select
        onFocus={() => (isFocusedRef.current = true)}
        onBlur={() => (isFocusedRef.current = false)}
        placeholder={placeholder}
        size={size || "large"}
        autoFocus
        showSearch
        style={{ width: length || '100%'  }}
        filterOption={(input, option) =>
          option?.children?.toLowerCase().includes(input.toLowerCase())
        }
        value={value || null}
        onChange={handleChange}
        disabled={disabled}
        ref={productRef ? productRef : null}
        prefix={<BarcodeOutlined style={{ fontSize: 23 }} />}
      >
        {options.map((item) => (
          <Option key={item.netsuite_id} value={item.netsuite_id}>
            {`${item?.code} - ${item?.name}`}
          </Option>
        ))}
      </Select>
  );
};

export default ProductScanSelect;
